import { OrganizationRoleType } from "@/types/graphql/admin.generated";

/**
 * Подписи ролей сотрудника организации для UI админки.
 */
export const ORGANIZATION_ROLE_LABELS: Record<OrganizationRoleType, string> = {
  [OrganizationRoleType.AdminType]: "Администратор",
  [OrganizationRoleType.AnalyticsType]: "Аналитика",
  [OrganizationRoleType.VideosType]: "Видео",
  [OrganizationRoleType.StreamsType]: "Трансляции",
  [OrganizationRoleType.ProductsType]: "Продукты",
  [OrganizationRoleType.UsersType]: "Пользователи",
  [OrganizationRoleType.MarketingType]: "Маркетинг",
  [OrganizationRoleType.SettingsType]: "Настройки",
};

// Порядок ролей в чекбоксах и чипах: как в спеке организации.
export const ORGANIZATION_ROLE_ORDER: OrganizationRoleType[] = [
  OrganizationRoleType.AdminType,
  OrganizationRoleType.AnalyticsType,
  OrganizationRoleType.VideosType,
  OrganizationRoleType.StreamsType,
  OrganizationRoleType.ProductsType,
  OrganizationRoleType.UsersType,
  OrganizationRoleType.MarketingType,
  OrganizationRoleType.SettingsType,
];

export const ORGANIZATION_ROLE_OPTIONS = ORGANIZATION_ROLE_ORDER.map(
  (value) => ({
    value,
    label: ORGANIZATION_ROLE_LABELS[value],
  })
);

export function getOrganizationRoleLabel(role: OrganizationRoleType): string {
  return ORGANIZATION_ROLE_LABELS[role] ?? role;
}
